import DialogGamingLevel from '~/components/dialog/gaming/level/DialogGamingLevel.vue';
import { getResponseHeader } from '~/lib/utils/fetch';

export const useGamingLevelHeader = () => {
  const dialog = useDialogStore();
  const gaming = useGamingStore();

  const update = (response) => {
    const levelHeader = getResponseHeader(
      response,
      AdamHeader.NomadGamingLevel
    ) as string;
    const newLevelHeader = getResponseHeader(
      response,
      AdamHeader.NomadGamingReachedNewLevel
    );
    const lowPrioNewLevelHeader = getResponseHeader(
      response,
      AdamHeader.NomadGamingReachedNewLevelWithLowPriority
    );
    if (levelHeader) {
      gaming.setLevel(parseInt(levelHeader, 0));
    }
    // removed current popin (en attente nouveaux designs)

    // if (newLevelHeader === 'true' && lowPrioNewLevelHeader === 'false') {
    //   dialog.open(DialogGamingLevel, { level: DialogLevel.Reward });
    // }
  };
  return {
    update,
  };
};
